import React, { useRef, ReactNode, useState, useEffect, Suspense } from 'react';

const LinesBackground = React.lazy(() => import('./LinesBackground'));

interface PageWrapperProps {
  children: ReactNode;
  showLines?: boolean;
  bgClass?: string;
}

export default function PageWrapper({ children, showLines = true, bgClass = "bg-[#F8F8F8]" }: PageWrapperProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [shouldRenderLines, setShouldRenderLines] = useState(false);

  useEffect(() => {
    // Delay loading and measuring SVG lines to allow the page mount and core LCP/FCP paints to settle.
    // This removes heavy Framer Motion computations from the initial main thread timeline.
    const timer = setTimeout(() => {
      setShouldRenderLines(true);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div ref={containerRef} className={`relative z-20 ${bgClass} w-full overflow-x-clip`}>
      {/* CONTENT */}
      <div className="relative z-10 w-full overflow-visible">
        {children}
      </div>

      {/* LINES SVG */}
      {showLines && shouldRenderLines && (
        <Suspense fallback={null}>
          <LinesBackground containerRef={containerRef} />
        </Suspense>
      )}
    </div>
  );
}
